export default __webpack_public_path__ + "static/media/logo.ddf2a953.svg";